<template lang="pug">
    .container
        #privacy
            h2
                img(src="@/assets/img/photo/contact/privacy.svg")
            section(v-for="(item,index) in text",:class="{'-first':index===0}")
                h3 第{{index+1}}条({{item.title}})
                p(v-html="nl2br(item.contents)")
        backtoTop
        footerBlock
</template>
<style lang="scss" scoped>
#privacy {
    @include container;
    font-family: $font-main;
    > h2 {
        text-align: center;
        padding: 128px 0;

        > img {
            width: 180px;
        }
    }

    > section {
        margin: 60px 0;
        &.-first {
            margin-top: 0;
        }
        > h3 {
            font-size: 15px;
            margin-bottom: 25px;
            font-weight: normal;
        }

        > p {
            color: #4d4d4d;
        }
    }
}
</style>
<script>
import footerBlock from "@/components/footer-block";
import backtoTop from "@/components/backto-top";
export default {
    components: {
        footerBlock,
        backtoTop
    },
    mounted() {
        window.scroll(0, 0);
    },
    data() {
        return {
            text: [
                {
                    title: "総則",
                    contents:
                        "リノデ リュクス、株式会社ティーエス・ハマモト(以下「当社」といいます)は、次の各号に掲げるサービス(以下「本サービス」といいます)をお申込者様(以下「お客様」とい います)にご提供するに際し、当社所定の「個人情報保護方針」及び「個人情報の取扱いに関する規約(」以下「本規約」といいます)に基づき、お客様よりお預かりした特定の 個人を識別するための情報(以下「個人情報」といいます)を適切に取り扱うものとします。\n(1)ご希望の工事・リフォーム関連資料を送付するサービス\n(2)工事・リフォームに関するお問合せ(ご質問、ご相談等)に回答するサービス\n(3)ダイレクトメールを定期的に発信するサービス"
                },
                {
                    title: "利用目的",
                    contents:
                        "当社は、次の各号に掲げる目的の達成に必要な範囲内において個人情報を利用できるものとします。\nなお、当社は、お客様ご本人から新たに同意を得ることなく、個人情報をその他の目的のために使用いたしません。 (1)工事・リフォーム関連資料の送付\n(2)ダイレクトメールの発信\n(3)本サービスに関するお問合せ(ご質問、ご相談等)への回答\n(4)前各号に掲げる目的に付帯関連するお客様への通知・連絡"
                },
                {
                    title: "個人情報の第三者提供",
                    contents:
                        "当社は、お客様ご本人からの同意を得ることなく、個人情報を第三者に対し提供いたしません。"
                },
                {
                    title: "個人情報の取扱いの委託",
                    contents:
                        "当社は、第2条各号の目的の達成に必要な範囲内において、個人情報の取扱いの一部又は全部を当社との間で適切に個人情報保護に関する契約を締結した委託先に委託 できるものとします。"
                },
                {
                    title: "個人情報の開示等及びお問合せ窓口",
                    contents:
                        "当社は、お客様からのご請求により、当社がお預かりしている個人情報の消去、利用目的の通知・開示、内容の訂正・追加・削除、利用の停止又は提供の停止(以下「開示等」と いいます)に応じます。なお、開示等のご請求窓口は次のとおりとします。\nリノデ リュクス\n株式会社 ティーエス・ハマモト\n〒731-0135 広島県広島市安佐南区長束4-17-7\nTEL 082-238-1511"
                }
            ]
        };
    },
    methods: {
        nl2br(str) {
            return str.replace(/\r?\n/g, "<br>");
        }
    }
};
</script>
